import { call, put } from "redux-saga/effects";
import Axios from "../../utils/axios";
import { ACCOUNT_LOGIN } from "../../state/user/constants";
import { loginDone, loginError, cleanNextUrl } from "../../state/user/actions";
import { setUserId, showErrorSnackbar } from "../../utils/util";
import { CREDENTIALS_ERROR_MESSAGE, SCHEDULED } from "../../constants";

function* loginAccount({ payload }) {
  try {
    const { clientId, email, password, history, nextUrl, shortName } = payload;
    const result = yield call(Axios.core.post, ACCOUNT_LOGIN, {
      clientId,
      email,
      password
    });

    if (result?.data) {
      const {
        success: loginSuccess,
        accountId: userId,
        firstName,
        lastName,
        token
      } = result.data;
      if (loginSuccess) {
        // Store Auth token
        yield call(Axios.setAuthToken, token.idToken);
        // Store user ID
        yield call(setUserId, userId);

        yield put(
          loginDone({ id: userId, username: email, firstName, lastName })
        );

        if (nextUrl) {
          yield call(history.push, nextUrl);
          yield put(cleanNextUrl());
        } else {
          // Redirect to scheduled page
          yield call(history.push, `/${shortName}/${SCHEDULED}`);
        }
      } else {
        showErrorSnackbar(CREDENTIALS_ERROR_MESSAGE, {
          removeOnHover: false
        });
      }
    }
  } catch (e) {
    showErrorSnackbar("Email and/or password is incorrect", {
      removeOnHover: false
    });
    yield put(loginError(e));
  }
}

export default loginAccount;
